// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1Z4ml","footer":"ModalCreateQualiphyProcedure_footer__3TNMN","additionData":"ModalCreateQualiphyProcedure_additionData__1ypyz"};